module.exports = __webpack_public_path__ + "img/02.d1a011c6.png";